module.exports = __webpack_public_path__ + "static/img/news_11.346043a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_11.jpg
// module id = 3h5p
// module chunks = 2